import {
    ImgBaseURL,
    TIMEOUT
} from './config';
import router from '../router'
import Qs from 'qs'
import {
    Toast
} from 'vant';
import store from '@/store'

//********************** XMLHttpRequest star ****************************
function responseInterceptor(response, resolve, reject) {
    const map = {
        'sucess': () => {
            const statusCode = response.status;
            const data = response.data;
            // setTimeout(() => {
            // 	Toast.clear();
            // }, 500)
            if (statusCode === 200) {
                //登录接口，用户信息接口返回信息无code判断
                if (response.config.useApi !== 'user' && response.config.useApi !== 'CurPost') {
                    if (data.code && data.code != 200 && data.code != 0) {
                        if (data.message || data.msg) {
                            const msg = data.message || data.msg
                            Toast(msg);
                        } else {
                            Toast('请求异常');
                        }
                    }
                    resolve(data)
                } else {
                    resolve(data)
                }
            } else {
                reject(response)
            }
        },
        'failed': () => {
            const errRes = (response && response.data) || response || {};
            if (response) { // 响应错误码处理
                switch (parseInt(errRes.status)) {
                    case 403:
                        Toast('拒绝访问');
                        break;
                    case 401:
                        store.commit('SET_TOKEN', '');
                        store.commit('SET_USERINFO', '');
                        store.commit('SET_REFRESH_TOKEN', '');
                        // localStorage.getItem('notPD')代表启动页为首页，通过tab跳转工作台，此时没有postType，所以缓存标识，使用完就销毁
                        localStorage.getItem('notPD') && localStorage.removeItem('notPD')
                        localStorage.removeItem("vuex");
                        router.push({
                            path: '/login'
                        });
                        Toast('登录已过期，请重新登录');
                        break;
                    default:
                        setTimeout(() => {
                            Toast(errRes.error_description || errRes.message || errRes.msg || `您的网络开小差了，请稍等或重新刷新页面...`);
                        }, 500)
                        break;
                }
                reject(errRes);
            }
            reject(errRes)
        }
    }
    if (response.status === 200) {
        map.sucess()
    } else {
        map.failed()
    }
}

function requestInterceptor(config) {

    // 如果请求是 post 的请求 用qs 配置下 请求参数
    if (config.method === 'POST') {
        if (config.stringify) {
            config.data = Qs.stringify(config.data);
        } else {
            const datatype = Object.prototype.toString.call(config.data)
            // 如果是普通对象或数组，则进行序列化处理
            if (datatype === '[object Object]' || datatype === '[object Array]') {
                config.data = JSON.stringify(config.data)
            }
        }
        return config;
    }

    // 如果请求是 put 的请求 用qs 配置下 请求参数
    if (config.method === 'PUT') {
        if (config.stringify) {
            config.data = Qs.stringify(config.data);
        } else {
            const datatype = Object.prototype.toString.call(config.data)
            // 如果是普通对象，则进行序列化处理
            if (datatype === '[object Object]') {
                config.data = JSON.stringify(config.data)
            }
        }
        return config;
    }

    //在get请求的参数中加上一个随机参数
    if (config.method === 'GET') {
        const random = Math.random();
        if (typeof config.params == 'object' && config.params !== null) {
            config.params.r = random;
            config.url += '?'
            for (let key in config.params) {
                config.url += `${key}=${config.params[key]}&`
            }
        } else {
            config.params = {
                r: random
            };
        }
        return config;
    }
}

function createInstance(method = 'GET', inputUrl, inputParams, inputData = null, config = {}) {
    const xhrPms = new Promise((resolve, reject) => {
        let xhr = {}
        if(window.plus) {
            xhr = new window.plus.net.XMLHttpRequest()
        } else {
            xhr = new XMLHttpRequest()
        }
        // const xhr = new XMLHttpRequest()
        try {

            xhr.onreadystatechange = function () {

                if (xhr.readyState === 1) {
                    //open()方法已调用，但是send()方法未调用。请求还没有被发送
                    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                    xhr.timeout = TIMEOUT;
                    const token = sessionStorage.getItem('token')//store.state.user.token;
                    // 登录相关接口，不需要添加token
                    if (token && config.useApi !== 'user') {
                        if (Object.prototype.toString.call(inputData) !== '[object FormData]') {
                            xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                        }
                        xhr.setRequestHeader('Authorization', 'Bearer ' + token)
                    }
                    // 设置自定义请求头
                    if (config.headers) {
                        for (let key in config.headers) {
                            xhr.setRequestHeader(key, config.headers[key])
                        }
                    }
                }
                if (xhr.readyState === 4) {
                    //Loaded，HTTP响应已经完全接收。
                    try {
                        var response = JSON.parse(xhr.responseText);
                        responseInterceptor({
                            status: xhr.status,
                            config: config,
                            data: response
                        }, resolve, reject)
                    } catch (e) {
                        console.error(e)
                        responseInterceptor({
                            status: xhr.status,
                            config: config,
                            data: xhr.responseText,
                        }, resolve, reject)
                    }
                }
            }
            // 请求拦截器里处理参数
            const {
                params,
                data,
                url
            } = requestInterceptor({
                ...config,
                url: inputUrl,
                params: inputParams,
                data: inputData,
                method
            })
            // const baseUrl = process.env.NODE_ENV === 'development' ? baseURL.dev  : baseURL.prod
            const absUrl = url
            if(url.indexOf('http')> -1) {
                xhr.open(method, absUrl, true)
            } else {
                xhr.open(method, ImgBaseURL + url, true)
            }

            xhr.send(data)

        } catch (e) {
            console.error('xhrError:', e)
            reject(e)
        }
    })
    return xhrPms
}

const httpInstance = {
    get: (url, params, config) => {
        return createInstance('GET', url, params, config)
    },
    post: (url, params, config) => {
        return createInstance('POST', url, params, params, config)

    },
    put: (url, params, config) => {
        return createInstance('POST', url, params, params, config)

    }
}
export default httpInstance

//********************** XMLHttpRequest end  ****************************

// axios 配置
// const xhr = axios.create({
//     baseURL: process.env.NODE_ENV === 'development' ? baseURL.dev  : baseURL.prod,
//     timeout: TIMEOUT,
//     headers: {
//         'Content-Type': 'application/json;charset=UTF-8'
// //		'Content-Type':'multipart/form-data'
// //		'Content-Type': 'application/x-www-form-urlencoded'
//     }
// });
// //添加请求拦截器
// xhr.interceptors.request.use(config => {
//         const token = store.state.user.token;
//         if(token && config.useApi !== 'user') {
//             config.headers.common["token"] = token;
//             config.headers.Authorization = 'Bearer ' + token
//         }

//         // 如果请求是 post 的请求 用qs 配置下 请求参数
//         if (config.method === 'post') {
//             if(config.stringify) {
//                 config.data = Qs.stringify(config.data);
//             }
//             return config;
//         }

//         // 如果请求是 put 的请求 用qs 配置下 请求参数
//         if (config.method === 'put') {
//             if(config.stringify) {
//                 config.data = Qs.stringify(config.data);
//             }
//             return config;
//         }

//         //在get请求的参数中加上一个随机参数
//         if (config.method === 'get') {
//             const random = Math.random();
//             if (typeof config.params == 'object') {
//                 config.params.r = random;
//             } else {
//                 config.params = {
//                     r: random
//                 };
//             }
//             return config;
//         }
//     },error => {
//         return Promise.reject(error);
//     }
// );

// // 添加响应拦截器
// xhr.interceptors.response.use(response => {
//     const statusCode = response.status;
//     const data = response.data;
//     Toast.clear();
//     if (statusCode === 200) {
//         //登录接口，用户信息接口返回信息无code判断
//         if(response.config.useApi !== 'user' && response.config.useApi !== 'CurPost'){
//             if (data.code && data.code !== 200) {
//             Toast(data.message);
//           }
//             return data
//         }else {
//             return data;
//         }
//     } else {
//         return Promise.reject(response);
//         // 接口异常返回
//         // statusCodeMsg.forEach(function (item) {
//         //     if (statusCode === item.code) {
//         //         return Promise.reject(data);
//         //     }
//         // });
//     }
// },error => {
// 	console.log(111, error.response)
//     const errRes = (error.response && error.response.data) || {};
//         if (error.response) { // 响应错误码处理
//             switch (parseInt(errRes.status)) {
//                 case 403:
//                     Toast('拒绝访问(403)');
//                     break;
//                 case 401:
//                     store.commit('SET_TOKEN','');
//                     store.commit('SET_USERINFO','');
//                     store.commit('SET_REFRESH_TOKEN','');
//                     localStorage.removeItem("vuex");
//                     router.push({path: '/login'});
//                     Toast('未授权，请重新登录（401）');
//                     break;
//                 default:
//                     Toast(errRes.error_description || `连接出错(${error.response.status})!`);
//                     break;
//             }
//             return Promise.reject(errRes);
//         }
//         if (error.request) { // 请求超时处理
//             if (error.request.readyState === 4 && error.request.status == 0) {
//                 // 当一个请求在上面的timeout属性中设置的时间内还没结束，则触发超时错误
//                 Toast('请求超时，请稍后重试');
//             }
//             return Promise.reject(error.request);
//         }
//         return Promise.reject(errRes);
//     });
// export default xhr;
